
jQuery(document).ready(function($){

    if($(".home .hero-section").length != 0){

        var hero_image      = $(".home .hero-section img");
        var hero_section = $(".home .hero-section");
        var hero_slides = $(".home .hero-section li");

        console.log('long slide', hero_slides.length);

        if($(hero_section).hasClass('animated-gif') == true){
            $(window).on('resize', function () {
                hero_slides.each(function(e,i) {
                    
                })
                var win = $(this);
                if (window.innerWidth > 560) {
                    hero_slides.each(function (index) {
                        console.log(index + ": " + $(this).text());
                        var hero_image = $(this).find('img');
                        $(hero_image).attr("uk-cover", "");
                        if ($(hero_image).attr('src') != $(hero_image).attr('data-src-desktop')) {
                            $(hero_image).attr('src', $(hero_image).attr('data-src-desktop'));
                        }
                    });
                    

                } else {
                    hero_slides.each(function (index) {
                        console.log(index + ": " + $(this).text());
                        var hero_image = $(this).find('img');
                        $(hero_image).attr("uk-cover", "");
                        if ($(hero_image).attr('src') != $(hero_image).attr('data-src-mobile')) {
                            $(hero_image).attr('src', $(hero_image).attr('data-src-mobile'));
                        }
                    });
                    

                }
            });
            if (window.innerWidth > 560) {
                hero_slides.each(function (index) {
                    console.log(index + ": " + $(this).text());
                    var hero_image = $(this).find('img');
                    $(hero_image).attr("uk-cover", "");
                    if ($(hero_image).attr('src') != $(hero_image).attr('data-src-desktop')) {
                        $(hero_image).attr('src', $(hero_image).attr('data-src-desktop'));
                    }
                });


            } else {
                hero_slides.each(function (index) {
                    console.log(index + ": " + $(this).text());
                    var hero_image = $(this).find('img');
                    $(hero_image).attr("uk-cover", "");
                    if ($(hero_image).attr('src') != $(hero_image).attr('data-src-mobile')) {
                        $(hero_image).attr('src', $(hero_image).attr('data-src-mobile'));
                    }
                });


            }
            // setInterval(function(){

                
        
            // }, 500);
        }

    }




});